import React, { useEffect, useRef, useState } from "react";
import DOMPurify from 'dompurify';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import apiClient from '../../../../services/apiClient';
import "./custom.css";
import UnitOption from "./UnitOption";
import CommonDropdownMenuThree from "../../../Shared/CommonDropdownMenuThree";
import CommonDropdownMenufour from "../../../Shared/CommonDropdownMenufour";

function ViewInvoiceInfoModal({ user, type, id, code, data, eventDate }) {
  const [pagescontent, setPagescontent] = useState([]);

  const [invoiceitems, setInvoiceitems] = useState([]);

  const [invoicepayments, setInvoicepayments] = useState([]);

  const [showsign, setshowsign] = useState(false);

  const [companylogo, setCompanylogo] = useState();

  const [phone, setPhone] = useState();
  const [companyemail, setCompanyemail] = useState();
  const [fname, setFname] = useState();
  const [lname, setLname] = useState();
  const [companyname, setcompanyname] = useState();
  const [customername, setcustomername] = useState("");
  const [invoicecode, setinvoicecode] = useState(0);
  const [purchageorder, setpurchageorder] = useState("");

  const [smartdate, setsmartdate] = useState(false);
  const [smartday, setsmartday] = useState("");
  const [smartmonth, setsmartmonth] = useState(false);
  const [smartyear, setsmartyear] = useState(false);
  const [proposalstabs, setProposalstabs] = useState([]);

  const options = ["Custom Date", "Smart date"];
  const options_sub = [
    "Payment is due on a fixed calendar date",
    "Payment due date is based on event or invoice date",
  ];
  const options2 = ["day(s)", "Week(s)", "month(s)"];
  const options3 = ["before event date", "after event date"];

  const currentDate = new Date();
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const formattedDate = `${
    months[currentDate.getMonth()]
  } ${currentDate.getDate()}, ${currentDate.getFullYear()}`;

  const [subtotalprice, setsubtotalprice] = useState(0);
  const [showTaxBox, setShowTaxBox] = useState(false);
  const [taxval, settaxval] = useState(0);
  const [discountval, setdiscountval] = useState(0);
  const [showDiscountBox, setShowDiscountBox] = useState(false);
  const [totalprice, settotalprice] = useState(0);

  const [showDueDateBox, setShowDueDateBox] = useState(null);

  const [popup, setpopup] = useState(false);
  const [placeholder2, setplaceholder2] = useState("Type Placeholder here");
  const [addedoptions, setaddedoptions] = useState([
    { listpotion: "option" },
    { listpotion: "option" },
  ]);
  const [question, setQuestion] = useState([]);
  const [title2, settitle2] = useState("Type your question here");

  useEffect(() => {
    //  dispatch(setTitle(data.sharedQuestionnaires.title));



    //  setshareduserdetail(data.user);

    settitle2(data.question1);
    setplaceholder2(data.placeholder1);

    const items = JSON.parse(data.items);
    setInvoiceitems(items);

    const payments = JSON.parse(data.payment);

    setInvoicepayments(payments);

    const pages = JSON.parse(data.pages || "[]");

    setPagescontent(Array.isArray(pages) ? pages : []);

    setCompanylogo(
      user.Main_Logo ? process.env.REACT_APP_BACKEND_URL + user.Main_Logo : null
    );

    setPhone(user.Phone_Number);
    setCompanyemail(user.Company_Email);
    setFname(user.first_name);
    setLname(user.last_name);

    setcustomername(data.customer_name);
    setinvoicecode(data.code);

    setpurchageorder(data.purchageorder);
  }, []);

  // Calculate actual dates for smart date payments when eventDate becomes available
  useEffect(() => {
    if (!eventDate || invoicepayments.length === 0) return;
    const [year, month, day] = eventDate.split("-").map(Number);
    let changed = false;

    const updated = invoicepayments.map((ptab) => {
      if (ptab.type === 'smartdate') {
        const result = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));
        const timeType = (ptab.timetype || '').toLowerCase();
        const direction = ptab.smartdirection || ptab.dueDate || ptab.paymentId || '';
        const isBefore = direction.includes('before');
        const isAfter = direction.includes('after event date') || direction.includes('after invoice');

        if (isBefore) {
          if (timeType === 'day(s)') result.setUTCDate(result.getUTCDate() - Number(ptab.smartdays));
          else if (timeType === 'week(s)') result.setUTCDate(result.getUTCDate() - (Number(ptab.smartdays) * 7));
          else if (timeType === 'month(s)') result.setUTCMonth(result.getUTCMonth() - Number(ptab.smartdays));
        } else if (isAfter) {
          if (timeType === 'day(s)') result.setUTCDate(result.getUTCDate() + Number(ptab.smartdays));
          else if (timeType === 'week(s)') result.setUTCDate(result.getUTCDate() + (Number(ptab.smartdays) * 7));
          else if (timeType === 'month(s)') result.setUTCMonth(result.getUTCMonth() + Number(ptab.smartdays));
        }

        changed = true;
        return {
          ...ptab,
          dueDate: new Date(result.toISOString()).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
          })
        };
      }
      return ptab;
    });

    if (changed) setInvoicepayments(updated);
  }, [eventDate, invoicepayments.length]);
  useEffect(() => {
    var subtotal = 0;
    invoiceitems.map((tab1) => {
      subtotal = subtotal + (parseFloat(tab1.itemtotalprice) || 0);
    });

    subtotal = Math.round(subtotal * 100) / 100;
    setsubtotalprice(subtotal);

    var calculatedTotal = subtotal;
    var taxValue = 0;
    var discountValue = 0;

    // taxper: "1" = percentage, "0" = dollar; tax = the actual value
    if (parseInt(data.taxper) != 0) {
      taxValue = Math.round(((parseFloat(data.tax) || 0) * subtotal / 100) * 100) / 100;
    } else {
      taxValue = Math.round((parseFloat(data.tax) || 0) * 100) / 100;
    }
    settaxval(taxValue.toFixed(2));
    calculatedTotal = calculatedTotal + taxValue;

    // discountper: "1" = percentage, "0" = dollar; discount = the actual value
    if (parseInt(data.discountper) != 0) {
      discountValue = Math.round(((parseFloat(data.discount) || 0) * subtotal / 100) * 100) / 100;
    } else {
      discountValue = Math.round((parseFloat(data.discount) || 0) * 100) / 100;
    }
    setdiscountval(discountValue.toFixed(2));
    calculatedTotal = calculatedTotal - discountValue;

    settotalprice(Math.round(calculatedTotal * 100) / 100);
  }, [invoiceitems]);

  return (
    <div
      className="modal fade"
      id={`exampleModali${id}${code}`}
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      style={{ background: "#fffff" }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
        style={{ minHeight: "700px" }}
      >
        <div className="modal-content">
          {/* Modal header */}
          <div className="modal-header bg-primary">
            <h5
              className="modal-title text-white w-100 text-center"
              style={{ textTransform: "uppercase" }}
            >
              {type}
            </h5>
            <button type="button" className="close" data-bs-dismiss="modal">
              <span aria-hidden="true" className="modal_button">
                <i className="fas fa-close"></i>
              </span>
              <span className="sr-only">Close</span>
            </button>
          </div>
          <div
            className="modal-body py-5 px-4"
            style={{ background: "#ffffff" }}
          >
            <div className="row">
              <div className="customer_details" style={{ textAlign: "left" }}>
                {/* Customer info */}
                {companylogo ? (
                  <>
                    {/*  <div className='logo'>
                              <h4>
                                <img src={companylogo} alt='Main Logo Preview' className='mainimgpath img-fluid' />
                              </h4>
                            </div> */}
                  </>
                ) : (
                  <></>
                )}
                {/* <div className='title'>
                          <h4>{companyname}</h4>
                        </div>
                        <div className='item'>
                          <span style={{ textTransform: "capitalize" }}>{fname} {lname} </span>
                          <span>{phone}</span>
                          <span>{companyemail}</span>

                        </div>  */}
              </div>

              <div
                className="text-editor px-1 py-1 bg-view-contract"
                style={{ textAlign: "left" }}
              >
                <section className="section_container">
                  {/* Customer Details here */}
                  <div
                    className="customer_details"
                    style={{ textAlign: "left" }}
                  >
                    {/* Customer info */}
                    {companylogo ? (
                      <>
                        {/*  <div className='logo'>
                              <h4>
                                <img src={companylogo} alt='Main Logo Preview' className='mainimgpath img-fluid' />
                              </h4>
                            </div> */}
                      </>
                    ) : (
                      <></>
                    )}
                    {/*   <div className='title'>
                          <h4>{companyname}</h4>
                        </div>
                        <div className='item'>
                          <span style={{ textTransform: "capitalize" }}>{fname} {lname} </span>
                          <span>{phone}</span>
                          <span>{companyemail}</span>

                        </div> */}
                  </div>

                  {/* Invoice content */}
                  <div className="invoice" style={{ textAlign: "left" }}>
                    <h3 style={{ margin: "0px 40px" }}>Invoice</h3>

                    {/* invoice table */}
                    <div className="invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4">
                      <div
                        className="table_item  invoice_td position-relative"
                        type="button"
                        style={{ textAlign: "left", paddingLeft: "50px" }}
                      >
                        <span className="hover_effect">Bill to</span>
                        <br />

                        <span>{customername}</span>
                      </div>
                      <div
                        className="table_item  invoice_td position-relative"
                        type="button"
                        style={{ marginRight: "6%", textAlign: "left" }}
                      >
                        <span className="hover_effect">invoice #</span>
                        <br />
                        <span>{invoicecode}</span>
                      </div>

                      <div
                        className="table_item  purchase_td position-relative"
                        style={{ marginRight: "1%", textAlign: "left" }}
                      >
                        <span className="hover_effect">Purchase order #</span>
                        <br />
                        <span>{purchageorder}</span>
                      </div>
                    </div>

                    <div className="invoice-table d-flex align-items-center flex-wrap justify-content-between mt-4">
                      <div></div>
                      <div className="table_item table_item_date_issued position-relative">
                        <span>&nbsp;Date Issued</span> <br />
                        <div
                          className="date position-absolute"
                          style={{ fontSize: "14px" }}
                        >
                          &nbsp;{formattedDate}
                        </div>
                      </div>
                      <div className="table_item position-relative">
                        <span>Next Payment Due</span>
                        <br />
                        <div
                          className="date position-absolute"
                          style={{ fontSize: "14px" }}
                        >
                          {invoicepayments.length ? invoicepayments[0].dueDate : ""}
                        </div>
                      </div>
                    </div>

                    {/* service area */}
                    <div className="service_area d-flex align-items-center justify-content-between py-3">
                      <div className="service_item">
                        <div className="service_info_top">
                          <span>SERVICE INFO</span>
                        </div>
                      </div>
                      <div className="service_item d-flex align-items-center">
                        <span className="me-5">QTY</span>
                        <span>UNIT</span>
                      </div>
                      <div className="service_item">
                        <span className="me-3">
                          {" "}
                          {/*TAX*/}&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;
                          &nbsp;&nbsp;&nbsp;{" "}
                        </span>
                        <span>PRICE</span>
                      </div>
                    </div>

                    {/* create new service */}
                    {/* Render dynamic services */}

                    {invoiceitems.map((service, index) => (
                      <div
                        key={index}
                        className="create_new_service flex-wrap d-flex align-items-center justify-content-between py-3 position-relative"
                      >
                        <div className="service_item position-relative">
                          <div
                            className="service_info_box"
                            style={{ marginTop: "41px" }}
                          >
                            <div className="service_info">
                              <input
                                type="text"
                                id={`name-${index}`}
                                placeholder="Type or Select a Service"
                                value={service.type}
                                disabled
                                style={{ background: "none" }}
                              />
                              <small></small>
                            </div>
                            <div className="desc mt-2">
                              {" "}
                              &nbsp;
                              {/* <textarea name="" className="textare" placeholder='Enter a description' value={service.descp}  onChange={(e) => changedesc(e,index)}></textarea> */}
                              {/* <input type='text' placeholder='Enter a description' value={service.descp}  onChange={(e) => changedesc(e,index)} /> */}
                            </div>
                          </div>

                          {/* Select item */}
                        </div>
                        <div className="service_item d-flex align-items-center">
                          {/* QYT field */}
                          <span className="me-2 qyt">{service.qty}</span>

                          {/* UNIT Field */}
                          <span className="position-relative">
                            <UnitOption
                              indexval={index}
                              rawselectedOption={service.unit_option}
                            />
                          </span>
                        </div>
                        <div className="service_item d-flex align-items-center">
                          <div className="form-check ">
                            {/* <input
                              className='form-check-input'
                              type='checkbox'
                              name='tax'
                              value=''
                              id='flexCheckDefault'
                              checked={service.tax ? 'checked' : ''}
                            /> */}
                          </div>
                          <div className="form-check qyt">
                            {service.price}

                            <small></small>
                          </div>
                        </div>

                        {/* Delete button */}

                        <div className="textare2 left">
                          <p style={{ borderBottom: "1px solid #ccc" }}>
                            {" "}
                            {service.descp}{" "}
                          </p>

                          {/*  <textarea  placeholder='Enter a description' rows={1}  name={index} id={`desc-${index}`} className="textare" value={service.descp}
                                disabled style={{ borderBottom: 'none !important' }} />
                                */}
                          <small></small>
                        </div>
                      </div>
                    ))}

                    {/* add new item button  */}

                    {/* Summary*/}
                    <div className="card-body">
                      <div className="row flex-column-reverse flex-md-row row-gap-4 row-gap-md-0">
                        <div className="col-md-5 d-flex align-items-end"></div>

                        <div className="col-md-7 ml-auto">
                          <table className="table create_invoice_table table-clear">
                            <tbody>
                              <tr>
                                <td className="left">
                                  <span>Subtotal</span>
                                </td>
                                <td className="right">${(Number(subtotalprice) || 0).toFixed(2)}</td>
                              </tr>
                              {/* Tax box */}
                              <tr>
                                <td className="left position-relative">
                                  <span className="pointer">
                                    Tax {/* <span>8.5%</span> */}
                                  </span>
                                  {showTaxBox && (
                                    <div className="edit_discount_box edit_tax_box position-relative">
                                      <div className="box_header d-flex align-items-center justify-content-between mb-2">
                                        <h5>Edit Tax</h5>
                                        <span>
                                          <i className="fas fa-close"></i>
                                        </span>
                                      </div>
                                      <div className="box-content mt-2 d-flex align-items-center">
                                        <input
                                          type="number"
                                          className="me-2"
                                          placeholder="Tax"
                                          defaultValue=""
                                        />

                                        <div className="input-group">
                                          <span
                                            className={`input-group-text `}
                                            id="basic-addon1"
                                          >
                                            %
                                          </span>
                                          <span
                                            className={`input-group-text `}
                                            id="basic-addon1"
                                          >
                                            $
                                          </span>
                                        </div>

                                        {/* delete button */}
                                        <div>
                                          {" "}
                                          <i className="fas fa-trash text-danger"></i>
                                        </div>
                                      </div>

                                      <div className="discount_arrow"></div>
                                    </div>
                                  )}
                                </td>
                                <td className="right">${taxval}</td>
                              </tr>

                              {/* add discount box */}
                              <tr>
                                <td className="left position-relative">
                                  {showDiscountBox ? (
                                    <span className="pointer">Discount</span>
                                  ) : (
                                    <span className="pointer">
                                      + Add Discount
                                    </span>
                                  )}

                                  {/* edit discount box */}
                                  {showDiscountBox && (
                                    <div className="edit_discount_box position-relative">
                                      <div className="box_header d-flex align-items-center justify-content-between mb-2">
                                        <h5>Edit Discount</h5>
                                        <span>
                                          <i className="fas fa-close"></i>
                                        </span>
                                      </div>
                                      <div className="box-content mt-2 d-flex align-items-center">
                                        <input
                                          type="number"
                                          className="me-2"
                                          defaultValue=""
                                        />

                                        <div className="input-group">
                                          <span
                                            className={`input-group-text `}
                                            id="basic-addon1"
                                          >
                                            %
                                          </span>
                                          <span
                                            className={`input-group-text `}
                                            id="basic-addon1"
                                          >
                                            $
                                          </span>
                                        </div>

                                        {/* delete button */}
                                        <div>
                                          {" "}
                                          <i className="fas fa-trash text-danger"></i>
                                        </div>
                                      </div>

                                      <div className="discount_arrow"></div>
                                    </div>
                                  )}
                                </td>
                                <td className="right">
                                  <strong>${discountval}</strong>
                                </td>
                              </tr>
                              <tr>
                                <td className="left">
                                  <span>Total USD</span>
                                </td>
                                <td className="right">
                                  <strong> {(Number(totalprice) || 0).toFixed(2)} </strong>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="section_container my-4 px-2 px-md-5 py-5">
                  <div className="title">
                    <h4>PAYMENT SCHEDULE</h4>
                  </div>

                  <div className="payment_schedule_container mt-2">
                    <table>
                      <thead>
                        <tr>
                          <th scope="col" style={{ width: "74px" }}>
                            AMOUNT
                          </th>
                          <th scope="col">DUE DATE</th>
                          <th scope="col">PAYMENT DATE</th>
                          <th scope="col">PAYMENT ID</th>
                          <th scope="col" style={{ width: "74px" }}>
                            STATUS
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoicepayments.map((datarow, i) => (
                          <tr key={i}>
                            <td data-label="Amount">
                              <span className="hover_item">
                                ${(Number(datarow.amount) || 0).toFixed(2)}
                              </span>
                            </td>
                            <td
                              data-label="DUE DATE"
                              className="due_date hover_payment position-relative"
                            >
                              <span className="hover_item">
                                {datarow.dueDate}

                                {showDueDateBox === i && (
                                  <div className="due_date_box">
                                    <div className="due_date_box_header d-flex align-items-center justify-content-between">
                                      <h4>Set Payment Due</h4>
                                      <span>
                                        <i className="fas fa-close"></i>
                                      </span>
                                    </div>
                                    <div className="arrow"></div>

                                    <div className="due_date_box_content mt-2">
                                      {smartdate && (
                                        <CommonDropdownMenuThree
                                          options={options}
                                          suboption={options_sub}
                                          rawselectedOption={options[1]}
                                        />
                                      )}

                                      {!smartdate && (
                                        <CommonDropdownMenuThree
                                          options={options}
                                          suboption={options_sub}
                                          rawselectedOption={options[0]}
                                        />
                                      )}

                                      {smartdate && (
                                        <div className="d-flex smartdate">
                                          <input
                                            className="smardatinp"
                                            value={smartday}
                                            onChange={(e) =>
                                              setsmartday(e.target.value)
                                            }
                                          />
                                          &nbsp;
                                          <CommonDropdownMenufour
                                            options={options2}
                                          />
                                          &nbsp;
                                          <CommonDropdownMenufour
                                            options={options3}
                                          />
                                        </div>
                                      )}

                                      {!smartdate && (
                                        <div className="mt-3 date_input">
                                          <input type="date" />
                                        </div>
                                      )}

                                      <div className="mt-3 text-end">
                                        <button>Save</button>
                                      </div>
                                    </div>

                                    <div className="arrow"></div>
                                  </div>
                                )}
                              </span>
                            </td>
                            <td data-label="PAYMENT DATE">
                              {datarow.paid_at === "-"
                                ? datarow.paid_at
                                : new Date(datarow.paid_at).toLocaleDateString(
                                    "en-US",
                                    {
                                      timeZone: "UTC",
                                    }
                                  )}
                            </td>
                            <td data-label="PAYMENT ID">{String(datarow.paymentId ?? '').startsWith('PAY-') ? datarow.paymentId : invoicecode}</td>
                            <td
                              data-label="STATUS"
                              className="text-end position-relative"
                              style={{ cursor: "pointer" }}
                            >
                              {datarow.status}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* add new payment button  */}
                </section>

                {/* Invoice pages (from data.pages) */}
                {pagescontent.length > 0 && (
                  <section className="section_container my-4 px-2 px-md-5 py-5">
                    {pagescontent.map((page, index) => (
                      <div key={index} className="mb-4">
                        {page.page_name && (
                          <div className="title">
                            <h4>{page.page_name}</h4>
                          </div>
                        )}
                        <div
                          className="row left"
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(page.content || ""),
                          }}
                        />
                      </div>
                    ))}
                  </section>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewInvoiceInfoModal;
